<template>
  <ProfileAdminDropdown :data="data" />
</template>

<script>
export default {
  components: {
    ProfileAdminDropdown: () => import(/* webpackChunkName: "components--filters--admin" */ '@/components/buttons/ProfileAdminDropdown'),
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      options: {},
    };
  },
};
</script>
